<app-page-layout>
  <app-page-bar>
    <app-bar-back-button [link]="['/']"
                         [tooltip]="'Главная'"></app-bar-back-button>
    <app-bar-title>Тесты</app-bar-title>
    <button mat-icon-button *ngIf="canAdd"
            matTooltip="Добавить тест"
            (click)="openTestCreateDialog()">
      <mat-icon>add</mat-icon>
    </button>
  </app-page-bar>
  <app-page-content>
    <app-test-filters
      [filters]="filters"
      (apply)="onFiltersChange($event)"></app-test-filters>
    <mat-divider></mat-divider>
    <app-tests-table
      [displayedColumns]="displayedColumns"
      [sort]="sort"
      [dataSource]="dataSource"
      [pageSizeOptions]="pageSizeOptions"
      [pageSize]="pageSize"
      [pageNumber]="pageNumber"></app-tests-table>
  </app-page-content>
</app-page-layout>
